import React from 'react';
import './PrescriptionDisplay.css';

const PrescriptionDisplay = () => {
  return (
    <div className="prescription-display-container">
      <h3>Prescrição Médica</h3>
      <p>A prescrição médica será exibida aqui.</p>
    </div>
  );
};

export default PrescriptionDisplay;
